import UncontrolledPurchaseOrdersDataTable from './UncontrolledPurchaseOrdersDataTable';

export default UncontrolledPurchaseOrdersDataTable;
